
import {
    INIT,
    RESET,
    SET_DIAS,
    SET_DISABLED,
    SET_TIPO_GESTION,
   
} from './types';

export const initialStateDisabled={
    "siniestro":{disabled:false, radio:true},
    "patente": {disabled:false, radio:true},
    "idcaso": {disabled:false, radio:true},
    "idcarpeta": {disabled:false, radio:true},

    "tipogestion": {disabled:false, radio:true},    
    "tarea": {disabled:false, radio:true},    
    "estadocaso": {disabled:false, radio:false}, 
    "intanciajudicial": {disabled:false, radio:false}, 
    "situacion": {disabled:false, radio:false}, 
    "fechadesde": {disabled:false, radio:false},
    "fechahasta": {disabled:false, radio:false}, 
    "tipofecha": {disabled:false, radio:false}, 
    "audienciapendiente": {disabled:false, radio:false}, 
    "dias": {disabled:true, radio:false}, 
    "competencia": {disabled:false, radio:false}, 
    "jurisdiccion": {disabled:true, radio:false}, 
    "departamento": {disabled:true, radio:false},
    "municipio": {disabled:true, radio:false},
    "despacho": {disabled:true, radio:false},
}

export default function buscarReducer(state , action) {
    switch (action.type) {
        case RESET:
            return { ...state,
                siniestro:{...state.siniestro, disabled:false},
                patente:{...state.patente, disabled:false},
                idcarpeta:{...state.idcarpeta, disabled:false},
                tipogestion:{...state.tipogestion, disabled:false},
                tarea:{...state.tarea, disabled:false},
                estadocaso:{...state.estadocaso, disabled:false},
                intanciajudicial:{...state.intanciajudicial, disabled:false},
                idcaso:{...state.idcaso, disabled:false},
                situacion:{...state.situacion, disabled:false},
                fechadesde:{...state.fechadesde, disabled:false},
                fechahasta:{...state.fechahasta, disabled:false},
                tipofecha:{...state.tipofecha, disabled:false},
                audienciapendiente:{...state.audienciapendiente, disabled:false},
                dias:{...state.dias, disabled:false},
                competencia:{...state.competencia, disabled:false},
                jurisdiccion:{...state.jurisdiccion, disabled:false},
                departamento:{...state.departamento, disabled:false},  
                municipio:{...state.municipio, disabled:false},
                despacho:{...state.despacho, disabled:false}   
            }
        case INIT:
            return { ...state,
                siniestro:{...state.siniestro, disabled:false},
                patente:{...state.patente, disabled:false},
                idcarpeta:{...state.idcarpeta, disabled:false},
                tipogestion:{...state.tipogestion, disabled:true},
                tarea:{...state.tarea, disabled:false},
                estadocaso:{...state.estadocaso, disabled:false},
                intanciajudicial:{...state.intanciajudicial, disabled:true},
                idcaso:{...state.idcaso, disabled:false},
                situacion:{...state.situacion, disabled:true},
                fechadesde:{...state.fechadesde, disabled:true},
                fechahasta:{...state.fechahasta, disabled:true},
                tipofecha:{...state.tipofecha, disabled:true},
                audienciapendiente:{...state.audienciapendiente, disabled:true},
                dias:{...state.dias, disabled:false},      
                competencia:{...state.competencia, disabled:false},
                jurisdiccion:{...state.jurisdiccion, disabled:true},
                departamento:{...state.departamento, disabled:true},       
                municipio:{...state.municipio, disabled:true},
                despacho:{...state.despacho, disabled:true}  
            }
        case SET_DISABLED:
            action.payload.name

            return { ...state,[action.payload.name]:{...[action.payload.disabled], disabled:[action.payload.disabled]} }
        
         case SET_TIPO_GESTION:
             return { ...state, [action.payload.name]:{...[action.payload.disabled], disabled:[action.payload.disabled]},  estado:{...state.estado, disabled:true}, situacion:{...state.situacion, disabled:true}, audienciapendiente:{...state.audienciapendiente, disabled:true},}
        case SET_DIAS:
            return { ...state, dias:{...state.dias, disabled:action.payload}}
     
        
        
       
       
        default:
            return state
    }
}